import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class COESecuredReportService {
  constructor(private http: HttpUtilService) {}

  CoeSecured(model: {}): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/CoeSecured`,
      {
        model,
      },
      undefined,
      60000,
    );
  }
}
